module.exports = __webpack_public_path__ + "img/corona-generator.43129e31.jpg";